module.exports = __webpack_public_path__ + "static/media/rectangle-view-on.03dd6070.svg";